export default "/_next/static/fonts/FiveEyesCondensed-Bold-57d11e78f5cecdae2bbb243c05bfada2.woff2";